import { fields } from './fields';

/*
 * Venue detail page settings
 * defones which fields to be displayed in which tabs and in which order and according to plan
 */

export const contact_details_fields = {
  email: fields.email,
  phone: fields.phone,
  website: fields.website,
} as any;

export const social_media_fields = {
  facebook: fields.facebook,
  instagram: fields.instagram,
  linkedin: fields.linkedin,
  twitter: fields.twitter,
  youtube: fields.youtube,
  pinterest: fields.pinterest,
} as any;

const venue_intro = {
  basic: {
    plan: fields.plan,
    memberships: fields.memberships,
    rating: fields.rating,
    rateCnt: fields.rateCnt,
    name: fields.name,
    headline: fields.headline,
    description: fields.description,
    address: fields.address,
    lat: fields.lat,
    lng: fields.lng,
    street: fields.street,
    housenumber: fields.housenumber,
    postcode: fields.postcode,
    city: fields.city,
    state: fields.state,
    district: fields.district,
    country: fields.country,
    ...contact_details_fields,
    ...social_media_fields,
  },
  gold: {
    images: fields.images,
  },
} as any;

// General Information Tabs
const venue_properties = {
  basic: {
    general: {
      exhibition_indoor_m2: fields.exhibition_indoor_m2,
      exhibition_outdoor_m2: fields.exhibition_outdoor_m2,
      halls_count: fields.halls_count,
      conference_rooms: fields.conference_rooms,
      conference_total_pax: fields.conference_total_pax,
      conference_rooms_count: fields.conference_rooms_count,
      conference_largest_room_pax: fields.conference_largest_room_pax,
      conference_largest_room_m2: fields.conference_largest_room_m2,
    },
  },
  gold: {
    general: {
      exhibition_indoor_m2: fields.exhibition_indoor_m2,
      exhibition_outdoor_m2: fields.exhibition_outdoor_m2,
      halls_count: fields.halls_count,
      hall_min_m2: fields.hall_min_m2,
      hall_max_m2: fields.hall_max_m2,
      standard_rate_m2: fields.standard_rate_m2,
      discount_offseason_perc: fields.discount_offseason_perc,
      discount_construction_perc: fields.discount_construction_perc,
      conference_rooms: fields.conference_rooms,
      conference_total_pax: fields.conference_total_pax,
      conference_rooms_count: fields.conference_rooms_count,
      conference_largest_room_pax: fields.conference_largest_room_pax,
      conference_largest_room_m2: fields.conference_largest_room_m2,
      barrier_free_access: fields.barrier_free_access,
      free_wifi: fields.free_wifi,
      car_parking: fields.car_parking,
      truck_parking: fields.truck_parking,
      distance_city_centre: fields.distance_city_centre,
      broadcasting_studio: fields.broadcasting_studio,
      theme_policy: fields.theme_policy,
      events: fields.events,
      largest_event: fields.largest_event,
    },
    security: {
      iso_certification: fields.iso_certification,
      sustainability_policy: fields.sustainability_policy,
      zero_carbon: fields.zero_carbon,
      health_measures: fields.health_measures,
    },
    catering: {
      onsite_restaurants: fields.onsite_restaurants,
      onsite_restaurants_pax: fields.onsite_restaurants_pax,
      inhouse_catering: fields.inhouse_catering,
      caterer_choice: fields.caterer_choice,
    },
    promotion: {
      promotion: fields.promotion,
    },
  },
  platinum: {
    map: {
      map: fields.map,
      map_url: fields.map_url,
    },
  },
} as any;

const fields_restaurant = {
  name: fields.name,
  description: fields.description,
  capacity: fields.capacity,
};

const venue_restaurants = [{ fields_restaurant }] as any;

/**
 * Ratings
 * graphql type Review
 */
const venue_ratings = {
  organizer: {
    accessibility: {
      transportation: 0,
      appeal: 0,
      wayfinding: 0,
    },
    services: {
      onsite_catering: 0,
      health_measures: 0,
      onsite_services: 0,
    },
    logistics: {
      facilities: 0,
      technology: 0,
    },
    appearance: {
      upkeep: 0,
      cleanliness: 0,
      restrooms: 0,
    },
    management: {
      professionality: 0,
      flexibility: 0,
      sustainability: 0,
      health_efforts: 0,
    },
    satisfaction_overall: {
      value_money: 0,
      satisfaction_venue: 0,
      recommend: 0,
    },
  },
  visitor: {
    accessibility: {
      transportation: 0,
      appeal: 0,
      wayfinding: 0,
    },
    appearance_services: {
      cleanliness: 0,
      restrooms: 0,
      onsite_catering: 0,
      onsite_services: 0,
    },
    satisfaction_overall: {
      satisfaction_destination: 0,
      satisfaction_venue: 0,
      recommend: 0,
    },
  },
  exhibitor: {
    accessibility: {
      transportation: 0,
      appeal: 0,
      wayfinding: 0,
    },
    logistics: {
      logistics_ease: 0,
      technical: 0,
    },
    services: {
      security: 0,
      onsite_catering: 0,
      staff: 0,
    },
    appearance: {
      upkeep: 0,
      cleanliness: 0,
      restrooms: 0,
      hall: 0,
    },
    satisfaction_overall: {
      satisfaction_venue: 0,
      recommend: 0,
    },
  },
} as any;

const service_ratings = {
  organizer: {
    satisfaction_overall: {
      service_quality: 0,
      timeliness: 0,
      value_money: 0,
      recommend: 0,
    },
  },
  visitor: {
    satisfaction_overall: {
      service_quality: 0,
      timeliness: 0,
      value_money: 0,
      recommend: 0,
    },
  },
  exhibitor: {
    satisfaction_overall: {
      service_quality: 0,
      timeliness: 0,
      value_money: 0,
      recommend: 0,
    },
  },
};

/**
 * Hall & Rooms
 * graphql type VenueSpace
 */
export const spacesSortKeys = {
  exhibition_hall: ['area', 'l_w_h', 'floors', 'partition_max_rooms'],
  conference: ['area', 'l_w_h', 'capacity_per_type'],
  multi_purpose_hall: ['area', 'l_w_h', 'capacity_pax'],
  room: ['area', 'l_w_h', 'capacity_pax'],
} as any;

const venue_spaces = {
  basic: {
    exhibition_hall: [],
    conference: [],
    multi_purpose_hall: [],
    room: [],
  },
  gold: {
    exhibition_hall: [
      {
        area: fields.area,
        length: fields.length,
        width: fields.width,
        height: fields.height,
        l_w_h: fields.l_w_h,
        floors: fields.floors,
        partition_walls: fields.partition_walls,
        partition_max_rooms: fields.partition_max_rooms,
        electricity: fields.electricity,
        electric_capacity: fields.electric_capacity,
        internet_lan: fields.internet_lan,
        internet_wifi: fields.internet_wifi,
        internet_speed: fields.internet_speed,
        water: fields.water,
        air_conditioning: fields.air_conditioning,
        pressurised_air: fields.pressurised_air,
        installation_grid: fields.installation_grid,
        installation_grid_m2: fields.installation_grid_m2,
        rigging_grid: fields.rigging_grid,
        rigging_capcity: fields.rigging_capcity,
        columns: fields.columns,
        load_factor_kg_m2: fields.load_factor_kg_m2,
        loading_elevators: fields.loading_elevators,
        loading_ramps: fields.loading_ramps,
        gates: fields.gates,
        gates_height: fields.gates_height,
        gates_width: fields.gates_width,
        gates_w_h: fields.gates_w_h,
        natural_light: fields.natural_light,
        natural_light_blocking: fields.natural_light_blocking,
      },
    ],
    conference: [
      {
        area: fields.area,
        length: fields.length,
        width: fields.width,
        height: fields.height,
        l_w_h: fields.l_w_h,
        capacity_per_type: fields.capacity_per_type,
        pax_type_1: fields.pax_type_1,
        pax_type_2: fields.pax_type_2,
        pax_type_3: fields.pax_type_3,
        pax_type_4: fields.pax_type_4,
        pax_type_5: fields.pax_type_5,
        pax_type_6: fields.pax_type_6,
        level: fields.level,
        columns: fields.columns,
        partition_walls: fields.partition_walls,
        partition_max_rooms: fields.partition_max_rooms,
        natural_light: fields.natural_light,
        natural_light_blocking: fields.natural_light_blocking,
        flooring_material: fields.flooring_material,
        av_system: fields.av_system,
        internet_lan: fields.internet_lan,
        internet_wifi: fields.internet_wifi,
        internet_speed: fields.internet_speed,
        translator_booth: fields.translator_booth,
        podium: fields.podium,
        screen_projector: fields.screen_projector,
      },
    ],
    multi_purpose_hall: [
      {
        description: fields.description,
        area: fields.area,
        length: fields.length,
        width: fields.width,
        height: fields.height,
        l_w_h: fields.l_w_h,
        // capacity_max: fields.capacity_max, // same as area/Size ???
        capacity_pax: fields.capacity_pax,
        columns: fields.columns,
        partition_walls: fields.partition_walls,
        partition_max_rooms: fields.partition_max_rooms,
        load_factor_kg_m2: fields.load_factor_kg_m2,
        internet_lan: fields.internet_lan,
        internet_wifi: fields.internet_wifi,
        internet_speed: fields.internet_speed,
        natural_light: fields.natural_light,
        natural_light_blocking: fields.natural_light_blocking,
        fixed_seating: fields.fixed_seating,
        removable_seating: fields.removable_seating,
      },
    ],
    room: [
      {
        description: fields.description,
        area: fields.area,
        length: fields.length,
        width: fields.width,
        height: fields.height,
        l_w_h: fields.l_w_h,
        capacity_max: fields.capacity_max,
        level: fields.level,
        internet_lan: fields.internet_lan,
        internet_wifi: fields.internet_wifi,
        internet_speed: fields.internet_speed,
        natural_light: fields.natural_light,
        natural_light_blocking: fields.natural_light_blocking,
        air_conditioning: fields.air_conditioning,
        f_b_outlet: fields.f_b_outlet,
        flooring_material: fields.flooring_material,
      },
    ],
  },
  platinum: {
    exhibition_hall: [
      {
        floorplan: fields.floorplan,
        // images: []
      },
    ],
    conference: [
      {
        floorplan: fields.floorplan,
        // images: []
      },
    ],
    multi_purpose_hall: [
      {
        // images: [],
      },
    ],
    room: [
      {
        // images: []
      },
    ],
  },
} as any;

// Location Section
const venue_locations = {
  ground: {
    description: {
      lat: fields.lat,
      lng: fields.lat,
    }, //Map Object {id: "venueApp2"}
  },
  parking: {
    parking: fields.description,
  },
  transportation: {
    transportation: fields.description,
  },
  hotels: {
    hotels: fields.description,
  },
} as any;

const service_category_fields = {
  // type: fields.category,
  headline: fields.headline,
  description: fields.description,
  // images: [],
};

const service_categories = {
  construction: service_category_fields,
  design: service_category_fields,
  installation: service_category_fields,
  electricity: service_category_fields,
  lighting: service_category_fields,
  flooring: service_category_fields,
  furniture: service_category_fields,
  rigging: service_category_fields,
  catering: service_category_fields,
  printing: service_category_fields,
  photo_video: service_category_fields,
  registration: service_category_fields,
  logistics: service_category_fields,
  audio_visual: service_category_fields,
  staff: service_category_fields,
  cleaning: service_category_fields,
  travel: service_category_fields,
  deco: service_category_fields,
  other: service_category_fields,
} as any;

const venue_media = {
  marketing: [
    // {...media_fields, type: "video", image: "https://via.placeholder.com/400x400/dcecf4/aebdc4"},
    // {...media_fields, type: "document"},
    // {...media_fields, type: "image", image: "https://via.placeholder.com/400x400/dcecf4/aebdc4"}
  ],
  maps: [],
  docs: [],
  commercial: [],
  other: [],
} as any;

const service_media = {
  marketing: [
    // {...media_fields, type: "video", image: "https://via.placeholder.com/400x400/dcecf4/aebdc4"},
    // {...media_fields, type: "document"},
    // {...media_fields, type: "image", image: "https://via.placeholder.com/400x400/dcecf4/aebdc4"}
  ],
  docs: [],
  commercial: [],
  other: [],
} as any;

// Contact Section
export const departments = {
  sales: 'sales',
  finance: 'sales',
  management: 'management',
  marketing: 'management',
  operations: 'management',
  catering: 'management',
  security: 'management',
  hr: 'management',
} as any;

const venue_contacts = [] as any;

// Merge all fields depending on venue plan (basic / gold / platinum)
const venue_fields = {
  basic: {
    intro: venue_intro.basic,
    properties: venue_properties.basic,
    ratings: venue_ratings,
    spaces: venue_spaces.basic,
    locations: venue_locations,
  },
  gold: {
    intro: {
      ...venue_intro.basic,
      ...venue_intro.gold,
    },
    properties: venue_properties.gold,
    ratings: venue_ratings,
    spaces: venue_spaces.gold,
    locations: venue_locations,
    services: service_categories,
    contacts: venue_contacts,
  },
  platinum: {
    intro: {
      ...venue_intro.basic,
      ...venue_intro.gold,
    },
    properties: {
      ...venue_properties.gold,
      ...venue_properties.platinum,
    },
    // restaurants: venue_restaurants,
    ratings: venue_ratings,
    spaces: {
      ...venue_spaces.gold,
      exhibition_hall: [
        {
          ...venue_spaces.gold.exhibition_hall[0],
          ...venue_spaces.platinum.exhibition_hall[0],
        },
      ],
      conference: [
        {
          ...venue_spaces.gold.conference[0],
          ...venue_spaces.platinum.conference[0],
        },
      ],
      multi_purpose_hall: [
        {
          ...venue_spaces.gold.multi_purpose_hall[0],
          ...venue_spaces.platinum.multi_purpose_hall[0],
        },
      ],
      room: [
        {
          ...venue_spaces.gold.room[0],
          ...venue_spaces.platinum.room[0],
        },
      ],
    },
    locations: venue_locations,
    services: service_categories,
    media: venue_media,
    contacts: venue_contacts,
  },
};

export const display = {
  venue: venue_fields,
  service: {
    ...venue_fields,
    platinum: {
      ...venue_fields.platinum,
      ratings: service_ratings,
      media: service_media,
    },
  },
  serviceProvider: venue_fields,
} as any;
